import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import * as Yup from 'yup';
var validationSchema = {
    username: Yup.string().required(),
};
export var AppRestoreAccountPage = function (_a) {
    var onRestoreClick = _a.onRestoreClick, onBackClick = _a.onBackClick;
    var intl = useIntl();
    var _b = useState(''), username = _b[0], setUsername = _b[1];
    var _c = useState(false), isUsernameNotValid = _c[0], setUsernameValid = _c[1];
    var _d = useState(true), isSubmitButtonDisabled = _d[0], setSubmitButtonState = _d[1];
    var usernamePlaceholder = intl.formatMessage({
        id: 'restore.form.username'
    });
    var handleSubmit = function (event) {
        event.preventDefault();
        onRestoreClick(username);
    };
    var handleUsernameChange = function (event) {
        setUsername(event.currentTarget.value);
        try {
            var isValid = !validationSchema.username.validateSync(event.currentTarget.value);
            setUsernameValid(isValid);
            setSubmitButtonState(isValid);
        }
        catch (e) {
            setUsernameValid(true);
            setSubmitButtonState(true);
        }
    };
    return (React.createElement("div", { className: 'app-login-page' },
        React.createElement("div", { className: 'container' },
            React.createElement("div", { className: 'row justify-content-center align-items-center' },
                React.createElement(Form, { onSubmit: handleSubmit, "data-testid": 'submitFormResetPwd' },
                    React.createElement(Card, null,
                        React.createElement(Card.Header, null,
                            React.createElement(FormattedMessage, { id: 'restore.header' })),
                        React.createElement(Card.Body, null,
                            React.createElement(Card.Text, { as: 'div' },
                                React.createElement("p", null,
                                    React.createElement(FormattedMessage, { id: 'restore.form.text' })),
                                React.createElement(Form.Group, { controlId: 'userInput' },
                                    React.createElement(Form.Label, null,
                                        React.createElement(FormattedMessage, { id: 'restore.form.username' })),
                                    React.createElement(Form.Control, { autoFocus: true, type: 'text', value: username, placeholder: usernamePlaceholder, onChange: handleUsernameChange, isInvalid: isUsernameNotValid }),
                                    React.createElement(Form.Control.Feedback, { type: 'invalid' },
                                        React.createElement(FormattedMessage, { id: 'restore.form.error' }))))),
                        React.createElement(Card.Footer, null,
                            React.createElement("div", { className: 'd-flex' },
                                React.createElement(Button, { disabled: isSubmitButtonDisabled, variant: 'primary', type: 'submit' },
                                    React.createElement(FormattedMessage, { id: 'restore.confirm' })),
                                React.createElement(Button, { className: 'ml-auto', variant: 'secondary', onClick: onBackClick },
                                    React.createElement(FormattedMessage, { id: 'restore.backToLogin' }))))))))));
};
//# sourceMappingURL=app-restore-account-page.js.map